export default __webpack_public_path__ + "static/media/AERO40ARRAYr.ddefe230.png";